import { eventLogger } from '../../eventLogger';
import type { LogAnalyticsEventParams } from './types';
import { ablyUserAgent } from '@banhala/utils';

export const logAnalyticsEvent = ({
  ably_only_log = {},
  name,
  channel = ['firebase', 'amplitude', 'ablylog', 'facebook'],
  immediate,
  ...restParams
}: LogAnalyticsEventParams): void | Promise<void> => {
  if (channel.includes('pixel')) {
    // const hasContents = 'contents' in restParams?.analytics ?? false;
    const hasContents = typeof restParams.analytics?.contents !== 'undefined';
    const shouldStringifyContents = ablyUserAgent.isAndroid && hasContents;

    // 메타 이벤트 관리자에서 확인했을 때, 컨텐츠가 객체 형식이면 안드는 파라미터가 들어가지 않는 문제가 있어서 안드 컨텐츠만 stringify해서 보내줌
    const _analytics = shouldStringifyContents
      ? {
          ...restParams.analytics,
          contents: JSON.stringify(restParams.analytics?.contents),
        }
      : restParams.analytics;

    eventLogger.log({
      channel: ['facebook'],
      eventName: name,
      analytics: _analytics,
      ablyOnlyLog: ably_only_log,
    });

    if (channel.length === 1) {
      return;
    }
  }

  eventLogger.log({
    eventName: name,
    channel,
    ...restParams,
    ablyOnlyLog: ably_only_log,
  });

  if (immediate) {
    // 전송 실패가 후속 흐름을 막지 않도록 best-effort 처리.
    return eventLogger.flush().catch(() => undefined);
  }
  return;
};
